import apiClient from './apiClient';

const geoService = {
  /**
   * Reporta la ubicacion del navegador. La distancia y el veredicto los calcula
   * el backend: aqui solo se envian las coordenadas crudas.
   */
  checkin: async ({ latitude, longitude, accuracy, status, socketId }) => {
    const response = await apiClient.post('/geo/checkin', {
      latitude, longitude, accuracy, status, socketId,
    });
    return response.data;
  },

  /** Deja constancia de que el usuario vio la alerta y decidio continuar. */
  acknowledge: async (socketId) => {
    const response = await apiClient.post('/geo/acknowledge', { socketId });
    return response.data;
  },

  /** Mapa de accesos de un taller (superadmin). */
  getShopSessionMap: async (shopId, params = {}) => {
    const response = await apiClient.get(`/shops/${shopId}/session-map`, { params });
    return response.data;
  },
};

export default geoService;
